import React from "react";
import { Spinner, Text } from "@merge-api/merge-javascript-shared";

interface Props {
  message: string;
}

const SwitchProgress = ({ message }: Props) => {
  // render
  return (
    <div className="flex flex-col items-center gap-10">
      {/* The shared Spinner's largest size is 24px; this wrapper takes it to the design's 48px. */}
      <div className="text-gray-100 [&>span]:h-12 [&>span]:w-12">
        <Spinner variant="inherit" />
      </div>
      <Text variant="lg">{message}</Text>
    </div>
  );
};

export default SwitchProgress;
